import styled from "styled-components";

export const UserWelcomeStyled = styled.div`
  .img img {
    width: 48px;
    height: 48px;
    border-radius: 18px;
    box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.25);
    background-color: #ffbf1d;
    margin-left: 24px;
  }
`;
export const BadgeStyled = styled.button`
  padding: 2px 5px;
  color: #ffbf1d;
  background-color: rgba(255, 191, 29, 0.08);
  font-size: 0.75em;
  border-radius: 10px;
  padding-top: 1px;
  padding-bottom: 2px;
  border: solid 1px #ffbf1d;
`;
